import Eyebrow from './Eyebrow'

// The heading block that opens a section: optional eyebrow, the h2, an optional
// lead. One definition so every section on every page uses the same type scale
// (spec §2.2: h2 44/30, lead 21/18). Before this, the same h2 was hand set in
// five sizes across the site (26/34, 26/36, 30/40, 30/44, 34/52).
//
//   size  'lg'  a section's own heading (30 → 44). The default.
//         'md'  a heading inside a narrow reading column, or beside art (26 → 34)
//         'xl'  a trunk home's closing band only (34 → 52)
//   on    'navy' flips eyebrow and lead to the navy inks
//   align 'center' for a closing band

const SIZES = {
  md: 'text-[26px] md:text-[34px]',
  lg: 'text-[30px] md:text-[44px]',
  xl: 'text-[34px] md:text-[52px]',
}

export function H2({ size = 'lg', className = '', children, ...rest }) {
  return (
    <h2 className={`font-bold leading-[1.1] tracking-[-0.02em] ${SIZES[size]} ${className}`} {...rest}>
      {children}
    </h2>
  )
}

export default function SectionHead({
  eyebrow, title, lead, size = 'lg', on = 'light', align = 'left', className = '',
}) {
  const navy = on === 'navy'
  const centre = align === 'center'
  return (
    <div className={`${centre ? 'mx-auto text-center' : ''} max-w-[760px] ${className}`}>
      {eyebrow && <Eyebrow on={navy ? 'navy' : 'light'} className="mb-3">{eyebrow}</Eyebrow>}
      <H2 size={size}>{title}</H2>
      {lead && (
        <p className={`mt-5 max-w-[640px] text-[18px] leading-relaxed md:text-[19px] ${centre ? 'mx-auto' : ''} ${
          navy ? 'text-white/75' : 'text-ink-muted'
        }`}>
          {lead}
        </p>
      )}
    </div>
  )
}
